/*
 * MAIN SCRIPT
 * DON'T WRITE FUNCTION HERE, ONLY CALL THEM
 *
 * **/
// document event listeners
let isDocumentScrolled = false;
document.addEventListener('scroll', () => {
    //assure to trigger just once
    if (!isDocumentScrolled) {
        isDocumentScrolled = true;
        //here for core web vitals reasons
        initMapScript();
    }
});
const cardsAnimationTiming = 400;
document.addEventListener('DOMContentLoaded', (event) => {
    const formValidation = new FormsValidation();
    formValidation.initFormsValidation();
    initModalResponse();
    initLoadMore();
    initFilter();
    initVideo();
    initToggler();
    initCardComponent();
    initCardListTextCta();
    initFadeInAnimations();
    initfullWidthBannerSlider();
    initGallery();
    initSidebar();
    initBackgroundColorDetector();
    initHeaderOneLevelComponent();
    initCardListWidget();
    initPagesSliderWidget();
    initAccordionWidget();
    initPhotoVideoGalleryWidget();
    initFormModalComponent();
    initIubendaProof();
    initRecaptcha();
    initCookieScript();
    initCWV();
});
